import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './EventTypesGuideModal.css';

// Памятка по типам событий. Тексты те же, что видит организатор в форме создания
// события (events.hints.*) — правится подсказка в форме, меняется и памятка
const EVENT_TYPE_GUIDE = [
  { type: 'group_ride', hints: ['group_ride'] },
  { type: 'race', hints: ['race_single_route'] },
  { type: 'tournament', hints: ['tournament_multiple_routes'] },
  { type: 'open_tournament', hints: ['open_tournament'] }
];

const EventTypesGuideModal = ({ isOpen, onClose }) => {
  const { t } = useLanguage();

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="types-guide-overlay" onClick={onClose}>
      <div className="types-guide-modal" onClick={(e) => e.stopPropagation()}>
        <div className="types-guide-header">
          <h2>{t('events.type_guide.title')}</h2>
          <button
            type="button"
            className="types-guide-close"
            onClick={onClose}
            aria-label={t('common.close')}
          >
            ×
          </button>
        </div>

        <div className="types-guide-body">
          <ul className="types-guide-list">
            {EVENT_TYPE_GUIDE.map(({ type, hints }) => (
              <li key={type} className="types-guide-item">
                <span className={`event-type-badge event-type-${type}`}>
                  {t(`events.types.${type}`)}
                </span>
                <div className="types-guide-text">
                  {hints.map(hint => (
                    <p key={hint}>{t(`events.hints.${hint}`)}</p>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EventTypesGuideModal;
